var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("card-title-component", {
            attrs: { title: _vm.$t("invitations.receivedInvitationsTitle") }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-content" },
            [
              _c("b-table", {
                attrs: {
                  hover: "",
                  stacked: "lg",
                  small: "",
                  fixed: "",
                  items: _vm.localReceivedInvitations,
                  "total-rows": _vm.totalRows,
                  fields: _vm.fieldsReceived
                },
                scopedSlots: _vm._u([
                  {
                    key: "actions",
                    fn: function(row) {
                      return [
                        !row.item.locked
                          ? _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.acceptInvitation(row.item.id)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t("invitations.actions.accept")
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !row.item.locked
                          ? _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.rejectInvitation(row.item.id)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t("invitations.actions.reject")
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("card-title-component", {
            attrs: { title: _vm.$t("invitations.sentInvitationsTitle") }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-content" },
            [
              _c("b-table", {
                attrs: {
                  hover: "",
                  stacked: "lg",
                  small: "",
                  fixed: "",
                  items: _vm.localSentInvitations,
                  "total-rows": _vm.totalRows,
                  fields: _vm.fieldsSent
                },
                scopedSlots: _vm._u([
                  {
                    key: "actions",
                    fn: function(row) {
                      return [
                        !row.item.locked
                          ? _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.cancelInvitation(row.item.id)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t("invitations.actions.cancel")
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02b170be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02b170be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guardian/InvitationsComponent.vue
// module id = null
// module chunks = 